import React from 'react';
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Loading from '../components/common/Loading';

// Component called from Auth0 after user login satisfied. 
export const CallBackFromAuth0 = () => {

    console.log("Enter into CallBackFromAuth0.js");
    
    const { user } = useSelector(state => state.user);
    
    return  <>  
                {   (user && user.accounts[0] && user.accounts[0].id === -1)?
                        (
                            <Loading/>
                        ):(     
                            <Redirect to={"/home/" + user.accounts[0].id} />
                        )
                }
            </>
};

export default CallBackFromAuth0;

CallBackFromAuth0.contextTypes = {
    t: PropTypes.func
}
